export function escapeHtml(s, quote) {
  if (typeof (s) !== 'string') {
    s = s + '';
  }
  s = s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  if (quote) {
    s = s.replace(/"/g, '&quot;');
  }
  s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  if (quote) {
    s = s.replace(/"/g, '&quot;');
  }
  return s;
}
